module.exports = __webpack_public_path__ + "img/index_lou_icon_5_on.377340ef.png";